// FranchSlider.js
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Loader from "../loaderspinnercomponents/Loader";


const FranchSlider = ({ images = [] }) => {
    if (!images || images.length === 0) {
        return <Loader />;
    }

    return (
        <div className="franch-swiper-container">
            <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                autoplay={{ delay: 2500000, disableOnInteraction: false }}
                loop={true}
                navigation
                pagination={{ clickable: true }}
                className="franch-swiper"
            >
                {images.map((img, index) => (
                    <SwiperSlide key={index}>
                        <img
                            src={img}
                            alt={`Slide ${index + 1}`}
                            className="caro-img"
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default FranchSlider;
